import {Button, DialogActions, DialogContent, DialogTitle, Divider, Modal, ModalDialog} from "@mui/joy";
import React from "react";
import {useTranslation} from "react-i18next";

type AddServiceFormDialogProps = {
    open?: boolean,
    onClose?: () => void,
    onConfirm?: () => void,
    onCancel?: () => void,
    negativeActionLoading?: boolean,
    positiveActionLoading?: boolean,
    label?: string,
    message?: string,
}

const ActionConfirmationDialog = (props: AddServiceFormDialogProps) => {
    const {t}=useTranslation()
    return <Modal open={props.open} onClose={props.onClose}>
        <ModalDialog variant="outlined" role="alertdialog">
            <DialogTitle sx={{alignItems: "center"}}>
                {props.label}
            </DialogTitle>
            <Divider/>
            <DialogContent>
                {props.message}
            </DialogContent>
            <DialogActions>
                <Button variant="solid" color="danger" onClick={props.onConfirm} loading={props.negativeActionLoading}>
                    {t("confirmDialogActionButtonLabel")}
                </Button>
                <Button variant="plain" color="neutral" onClick={props.onCancel} loading={props.positiveActionLoading}
                        disabled={props.negativeActionLoading}>
                    {t("cancelDialogActionButtonLabel")}
                </Button>
            </DialogActions>
        </ModalDialog>
    </Modal>
}


export default ActionConfirmationDialog